import { render, staticRenderFns } from "./soldOutButBotPaidList.vue?vue&type=template&id=71c0517a"
import script from "./soldOutButBotPaidList.vue?vue&type=script&lang=js"
export * from "./soldOutButBotPaidList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports